export const isDev = process.env.NODE_ENV === 'development';
export const API_BASE_URL = process?.env?.LOCAL_API_BASE_URL ?? process.env?.API_URL;
export const SENTRY_DSN = process.env?.SENTRY_DSN ?? '';
export const PUBLIC_URL = process.env?.PUBLIC_URL;
export const LOCAL_API_BASE_URL = process.env?.LOCAL_API_BASE_URL;
export const KEYCLOAK_CLIENTID = process?.env?.REACT_APP_KEYCLOAK_CLIENTID || '';
export const REACT_APP_ENVIRONMENT = process?.env?.REACT_APP_ENVIRONMENT;
export const ADMIN_URL = process?.env?.LOCAL_ADMIN_URL ?? process?.env?.ADMIN_URL;
